<template>
  <div class="min-h-full flex flex-col justify-between">
    <!-- Heading -->
    <div class="flex justify-start items-center gap-1 w-full">
      <div class="w-[8px] h-[8px] rounded-full bg-[#A084E8]" />
            <div class="w-[35px] h-[8px] rounded-full bg-[#A084E8]" />
            <p class="text-[18px] laptop:text-[20px] font-semibold font-roboto pl-2 m-0 text-[#333333]">Check</p>
    </div>

    <!-- Description -->
    <div class="w-full py-2 mt-2">
      <p class="text-[14px] m-0 font-normal font-roboto text-[#333333]">
        Please upload a photo of the front and back of the check.
      </p>
    </div>

    <!-- Upload Boxes -->
    <div class="w-full py-2 mobile:mt-0 laptop:mt-4">
      <div class="mobile:block laptop:flex gap-4">
        <!-- Front -->
        <div class="mobile:w-full laptop:w-1/2">
          <label for="frontimage" class="text-[13px] font-normal font-roboto mb-[6px] text-[#666666]">Check front image<span class="ml-1 text-[#EE5851]">*</span></label>
          <div
class="w-full h-[150px] border-1 border-dashed border-[#D3D8E2] rounded-[10px] relative bg-[#FAFBFC]"
            @dragover.prevent @drop.prevent="onDrop($event, 'front')"
>
            <input
ref="frontInput" type="file" accept=".png,.jpg,.jpeg" class="hidden"
              @change="onFileChange($event, 'front')"
>
            <div v-if="frontImage" class="w-full h-full flex flex-col items-center justify-center">
              <img :src="frontImage" class="max-w-full max-h-[90%] object-contain">
              <button
class="group absolute -top-4 right-2 px-2 py-1 rounded-full w-8 h-8 flex items-center justify-center transition-all border border-[#EFEFEF] bg-white hover:!bg-[#F67280]"
                @click="removeImage('front')"
>
                <img
src="../../assets/images/trashIcon.png"
                  class="min-w-4 object-contain filter group-hover:invert group-hover:brightness-0"
>
              </button>
            </div>
            <div
v-else
              class="text-center min-w-full min-h-full cursor-pointer flex flex-col items-center justify-center"
              @click="$refs.frontInput.click()"
>
              <div class="w-[32px] h-[32px] p-[7px] mx-auto rounded-full bg-[#EEF2FF]">
                <img src="../../assets/images/upload-icon.svg" class="w-full object-contain">
              </div>
              <p class="text-[13px] font-medium mb-0 mt-[8px] text-[#333333]">
Click or drag and drop files to upload
</p>
              <p class="text-[11px] mb-0 text-[#8A9099]">
                Supported formats: PNG, JPG
              </p>
              <p class="text-[11px] font-medium mb-0 text-[#F15A14]">
Maximum size 10 MB
</p>
            </div>
          </div>
          <span v-if="frontImageError" class="text-[#EE5851] text-xs mt-1">This front image is required</span>
        </div>

        <!-- Back -->
        <div class="mobile:w-full laptop:w-1/2 mobile:mt-3 laptop:mt-0">
          <label for="backimage" class="text-[13px] font-normal font-roboto mb-[6px] text-[#666666]">Check back image<span class="ml-1 text-[#EE5851]">*</span></label>
          <div
class="w-full h-[150px] border-1 border-dashed border-[#D3D8E2] rounded-[10px] relative bg-[#FAFBFC]"
            @dragover.prevent @drop.prevent="onDrop($event, 'back')"
>
            <input
ref="backInput" type="file" accept=".png,.jpg,.jpeg" class="hidden"
              @change="onFileChange($event, 'back')"
>
            <div v-if="backImage" class="w-full h-full flex flex-col items-center justify-center">
              <img :src="backImage" class="max-w-full max-h-[90%] object-contain">
              <button
class="group absolute -top-4 right-2 px-2 py-1 rounded-full w-8 h-8 flex items-center justify-center transition-all border border-[#EFEFEF] bg-white hover:!bg-[#F67280]"
                @click="removeImage('back')"
>
                <img
src="../../assets/images/trashIcon.png"
                  class="min-w-4 object-contain filter group-hover:invert group-hover:brightness-0"
>
              </button>
            </div>
            <div
v-else
              class="text-center min-w-full min-h-full cursor-pointer flex flex-col items-center justify-center"
              @click="$refs.backInput.click()"
>
              <div class="w-[32px] h-[32px] p-[7px] mx-auto rounded-full bg-[#EEF2FF]">
                <img src="../../assets/images/upload-icon.svg" class="w-full object-contain">
              </div>
              <p class="text-[13px] font-medium mb-0 mt-[8px] text-[#333333]">
Click or drag and drop files to upload
</p>
              <p class="text-[11px] mb-0 text-[#8A9099]">
                Supported formats: PNG, JPG
              </p>
              <p class="text-[11px] font-medium mb-0 text-[#F15A14]">
Maximum size 10 MB
</p>
            </div>
          </div>
          <span v-if="backImageError" class="text-[#EE5851] text-xs mt-1">This back image is required</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useToast } from "vue-toastification";
const toast = useToast();
export default {
  data() {
    return {
      frontImage: null,
      backImage: null,
      frontImageFile: null,
      backImageFile: null,
      frontImageError: null,
      backImageError: null

    };
  },
  computed: {
    validationCheck() {
      if (!this.frontImageFile || !this.backImageFile) return false;
      return true;
    },
  },
  watch: {
    validationCheck: {
      handler(value) {
        this.$emit("validation-change", this.validationCheck)
      },
      immediate: true,
    },
  },
  methods: {
    onFileChange(event, type) {
      const file = event.target.files[0];
      if (file) this.handleFile(file, type);
    },
    onDrop(event, type) {
      const file = event.dataTransfer.files[0];
      if (file) this.handleFile(file, type);
    },
    handleFile(file, type) {
      if (file.size > 10 * 1024 * 1024) {
        toast.error("File size exceeds 10MB")
        return;
      }
      const reader = new FileReader();
      reader.onload = async (e) => {
        if (type === "front") {
          if (file.type === "application/pdf") {
            this.frontImage =  require("../../assets/images/pdf-img.svg");
          } else if (
            file.type ===
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          ) {
            this.frontImage = require("../../assets/images/docs-img.svg");
          } else if (file.type.startsWith("image/")) {
            this.frontImage = e.target.result;
          } else {
            this.frontImageError = "Unsupported file type";
            return;
          }
          this.frontImageFile = file;
          this.frontImageError = null;
        } else {
          if (file.type === "application/pdf") {
            this.backImage =  require("../../assets/images/pdf-img.svg");
          } else if (
            file.type ===
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          ) {
            this.backImage = require("../../assets/images/docs-img.svg");
          } else if (file.type.startsWith("image/")) {
            this.backImage = e.target.result;
          } else {
            this.backImageError = "Unsupported file type";
            return;
          }

          this.backImageFile = file;
          this.backImageError = null;
        }
      };

      reader.readAsDataURL(file);
    },
    removeImage(type) {
      if (type === "front") {
        this.frontImage = null;
        this.frontImageFile = null;
        this.frontImageError = true
        if (this.$refs.frontInput) this.$refs.frontInput.value = "";
      } else {
        this.backImage = null;
        this.backImageFile = null;
        this.backImageError = true
        if (this.$refs.backInput) this.$refs.backInput.value = "";
      }
    },


    checkValidation() {
      let isValid = true;
      if (!this.frontImageFile) {
        this.frontImageError = true
        isValid = false
      } else {
        this.frontImageError = null
      }
      if (!this.backImageFile) {
        this.backImageError = true
        isValid = false
      } else {
        this.backImageError = null
      }
      return isValid;
    },

    async getData() {
      return { back_image: this.backImageFile, front_image: this.frontImageFile }
    }

  },
};
</script>
